import type { MailboxInfo } from "owa-client-types";
import { owaDate } from "owa-datetime";
import { type AccountOcpsPoliciesState, OcpsPoliciesFetchState, } from "../store/schema/OutlookCloudPoliciesSchema";

type RefreshOcpsPolicies = (mailboxInfo: MailboxInfo) => void;

let refreshOcpsPolicies: RefreshOcpsPolicies | undefined;

export function registerOcpsPoliciesRefresh(refresh: RefreshOcpsPolicies): void {
    refreshOcpsPolicies = refresh;
}

export function refreshOcpsPoliciesIfExpired(mailboxInfo: MailboxInfo, accountPolicies: AccountOcpsPoliciesState | undefined): void {
    // A missing or invalid service expiration is normalized to undefined when stored. Trust the
    // service contract and avoid repeatedly fetching policies when no refresh deadline is known.
    if (!accountPolicies?.expirationTime) {
        return;
    }
    
    if (accountPolicies.fetchState === OcpsPoliciesFetchState.Succeeded &&
        owaDate("UTC") >= accountPolicies.expirationTime) {
        refreshOcpsPolicies?.(mailboxInfo);
    }
}
